import { MoonLoader } from 'react-spinners';
import { Typography } from '@mui/material';

import './TitledCircularProgress.scss';

function TitledCircularProgress({ title, size }) {
  return (
    <div className="titled-circular-progress">
      <Typography variant="h6">{title}</Typography>
      <MoonLoader size={size ? size : '35px'} />
    </div>
  );
}

export { TitledCircularProgress };
